import { View } from "react-native";

import { useTheme } from "../../utils/theme";

import type { ViewProps } from "react-native";
import type { TestProps } from "../../types";
export interface BoxProps extends ViewProps, TestProps {
  children: any;
}

/**
 * A primitive for building cards or other raised components.
 *
 * example: https://smartrent-ui.com/components/general/box
 */
export const Box = ({ children, testID, style, ...props }: BoxProps) => {
  const { colors, shadows, spacing, rounding } = useTheme();

  return (
    <View
      testID={testID}
      style={[
        {
          borderRadius: rounding.raisedSurface,
          padding: spacing.md,
          backgroundColor: colors.backgroundRaised,
        },
        shadows.box,
        style,
      ]}
      {...props}
    >
      {children}
    </View>
  );
};
